import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { ParkService } from '../../park.service';

@Injectable()
export class NpContentGuard implements CanActivate {
  constructor(private parkService: ParkService, private router: Router) {}
  path: ActivatedRouteSnapshot[];
  route: ActivatedRouteSnapshot;

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    const parkUrls: string[] = this.parkService.getParkUrls();
    if (parkUrls.includes(route.paramMap.get('name'))) {
      return true;
    } else {
      this.router.navigate(['//not-found']);
    }
  }
}
